import 'custom-event-polyfill'
import 'requestTimer'
import each from 'lodash/each'

export default class Accordion {
  constructor (selector, callback) {
    this.triggers = document.getElementsByClassName(selector)
    this.targets = []
    this.isAnimating = false
    this.callback = callback

    this.init()
    this.handleEvents()
  }

  init () {
    each(this.triggers, (el, i) => {
      this.targets[i] = document.getElementById(el.getAttribute('data-target'))
      this.targets[i].style.transition = 'height .3s'
    })
  }

  onTabChange () {
    each(this.targets, (el, i) => {
      this.triggers[i].classList.remove('is-active')
      this.targets[i].classList.remove('is-active')
      this.targets[i].style.height = 0
    })
  }

  handleEvents () {
    window.addEventListener('tab/change', this.onTabChange.bind(this))
    each(this.triggers, el => {
      el.addEventListener('click', this.onClick.bind(this))
    })
  }

  onClick (e) {
    e.preventDefault()
    e.stopPropagation()

    const index = [].slice.call(this.triggers).indexOf(e.currentTarget)

    if (!this.targets[index].classList.contains('is-active')) {
      this.active(index)
    } else {
      this.inactive(index)
    }
  }

  active (index) {
    const onTransitonEnd = e => {
      e.currentTarget.style.height = 'auto'
      this.isAnimating = false
      e.currentTarget.removeEventListener('transitionend', onTransitonEnd)
    }

    if (!this.isAnimating) {
      this.isAnimating = true
      this.targets[index].addEventListener('transitionend', onTransitonEnd)
      this.triggers[index].classList.add('is-active')
      this.targets[index].classList.add('is-active')
      this.targets[index].style.height = this.getTargetHeight(index)
    }

    if (this.callback) this.callback(this.triggers[index])
  }

  inactive (index) {
    const onTransitonEnd = e => {
      this.isAnimating = false
      e.currentTarget.removeEventListener('transitionend', onTransitonEnd)
    }

    if (!this.isAnimating) {
      this.targets[index].style.height = this.getTargetHeight(index)
      this.targets[index].addEventListener('transitionend', onTransitonEnd)
      requestTimeout(() => {
        this.triggers[index].classList.remove('is-active')
        this.targets[index].classList.remove('is-active')
        this.targets[index].style.height = 0
      }, 20)
    }
  }

  getTargetHeight (index) {
    const el = this.targets[index].children[0]
    const style = window.getComputedStyle(el)
    let height = el.offsetHeight

    height += parseInt(style.marginTop) + parseInt(style.marginBottom)
    return height + 'px'
  }
}



// WEBPACK FOOTER //
// ./src/komachi-official/assets/scripts/modules/Accordion.js